<template>
  <div class="mt-4">
    <div class="mt-5">
      <h5 class="font-size-15">รายการสินค้าที่เกี่ยวข้อง</h5>
    </div>

    <div class="card" v-if="showDataTable">
      <div class="card-body">
        <div class="row form-group">
          <div class="col-sm-12 col-md-9">
            <div id="tickets-table_length" class="dataTables_length">
              <span>จำนวน</span>
              <label class="d-inline-flex align-items-center">
                <b-form-select
                  v-model="perPage"
                  size="sm"
                  :options="pageOptions"
                  @change="getDetail()"
                  class="ml-3"
                ></b-form-select>
              </label>
              <span class="ml-2"
                >จากทั้งหมด {{ totalRecords | number }} รายการ</span
              >
            </div>
          </div>
          <div class="col-sm-12 col-md-3">
            <div class="input-group md-form form-sm text-md-right">
              <div class="input-group-prepend">
                <span class="input-group-text">
                  <span class="bx bx-search-alt"></span>
                </span>
              </div>
              <input
                v-model="search"
                class="form-control my-0 py-1"
                type="search"
                placeholder="ค้นหา"
                aria-label="Search"
              />
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <!-- <div class="row table-responsive" v-if="products"> -->
            <div class="row table-responsive">
              <b-table
                class="table table-centered table-nowrap"
                ref="producttable"
                :empty-text="'ไม่พบข้อมูล'"
                :show-empty="products === null || products.length == 0"
                :bordered="true"
                :items="products"
                align="center"
                v-bind:fields="productTablefields"
              >
                <template v-slot:cell(index)="data">
                  <div class="text-right">
                    {{ (data.index + 1) | number }}
                  </div>
                </template>
                <template v-slot:cell(id)="data">
                  <div class="text-center">
                    <router-link
                      tag="a"
                      target="_blank"
                      :to="{
                        name: 'products_information_edit',
                        params: { id: data.value },
                      }"
                    >
                      {{ data.value }}
                    </router-link>
                  </div>
                </template>
                <template v-slot:cell(product_names)="data">
                  <div>
                    <span class="badge-lang">TH</span
                    >{{
                      data.item.product_names.length > 0
                        ? data.item.product_names.find(f => f.type == 'PIM')
                            .display_name.th
                        : ''
                    }}
                    <br />
                    <span class="badge-lang">EN</span
                    >{{
                      data.item.product_names.length > 0
                        ? data.item.product_names.find(f => f.type == 'PIM')
                            .display_name.en
                        : ''
                    }}
                  </div>
                </template>
                <template v-slot:cell(sku_qty)="row">
                  <div class="text-center">
                    <b-button
                      variant="light"
                      @click="onToggleDetails(row, row.item.id)"
                    >
                      <b-badge variant="info">{{
                        row.item.sku_qty | number
                      }}</b-badge>
                      SKU
                      <i
                        :class="
                          row.detailsShowing
                            ? 'bx bx-caret-up'
                            : 'bx bx-caret-down'
                        "
                        title="More Detail"
                      ></i>
                    </b-button>
                  </div>
                </template>
                <template #row-details="row">
                  <div class="card bg-light">
                    <div class="card-body">
                      <h4 class="card-title">
                        รายการ SKU ของ {{ row.item.id }}
                      </h4>
                      <div class="table-responsive">
                        <b-table
                          class="table table-centered table-nowrap"
                          ref="productskutable"
                          :empty-text="'ไม่พบข้อมูล'"
                          :show-empty="
                            !row.item.productSkuItems ||
                              row.item.productSkuItems.length == 0
                          "
                          :bordered="true"
                          :items="row.item.productSkuItems"
                          align="center"
                          v-bind:fields="productSkuFields"
                        >
                          <template v-slot:cell(index)="data">
                            <div class="text-right">
                              {{ (data.index + 1) | number }}
                            </div>
                          </template>
                          <template v-slot:cell(product_names)="data">
                            <div>
                              <span class="badge-lang">TH</span
                              >{{
                                data.item.product_names.length > 0
                                  ? data.item.product_names.find(
                                      f => f.type == 'Online'
                                    ).display_name.th
                                  : ''
                              }}
                              <br />
                              <span class="badge-lang">EN</span
                              >{{
                                data.item.product_names.length > 0
                                  ? data.item.product_names.find(
                                      f => f.type == 'Online'
                                    ).display_name.en
                                  : ''
                              }}
                            </div>
                          </template>
                          <template
                            v-slot:cell(product_status.inventory)="data"
                          >
                            <span
                              class="label"
                              :class="'label-' + data.value.toLowerCase()"
                              v-html="data.value"
                            ></span>
                          </template>
                          <template v-slot:cell(product_status.sale)="data">
                            <span
                              class="label"
                              :class="'label-' + data.value.toLowerCase()"
                              v-html="data.value"
                            ></span>
                          </template>
                        </b-table>
                      </div>
                    </div>
                  </div>
                </template>
              </b-table>
            </div>
          </div>
        </div>
        <div class="row" v-if="products && products.length > 0">
          <div class="col-lg-4">
            <div style="position: relative; top: 7px">
              รายการที่ {{ firstRowOnPage | number }} -
              {{ lastRowOnPage | number }} จากทั้งหมด
              {{ totalRecords | number }} รายการ
            </div>
          </div>
          <div class="col-lg-8">
            <b-pagination
              :total-rows="totalRecords"
              :per-page="perPage"
              v-model="pageNo"
              @change="onClickPagination($event)"
              class="pagination pagination-rounded justify-content-end mb-2"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import brandService from '@/helpers/service/brand-service'
import productService from '@/helpers/service/product-service'
import { StatusEnum } from '@/enum/status.enum.js'
import { FormatQty } from '@/helpers/utils/format-qty.js'

export default {
  name: 'BrandProductRelate',
  components: {},
  props: {
    colorId: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      search: null,
      products: [],
      productTablefields: [
        {
          key: 'index',
          formatter: (value, key, item) => {
            return FormatQty(value ? value : 0)
          },
          label: 'ลำดับ',
          thStyle: 'width:80px',
          sortable: true,
        },
        {
          key: 'id',
          label: 'รหัสกลุ่มสินค้า',
          sortable: true,
        },
        {
          key: 'product_names',
          label: 'ชื่อกลุ่มสินค้า',
          sortable: true,
        },
        {
          key: 'sku_qty',
          label: 'จำนวน SKU',
          formatter: (value, key, item) => {
            return FormatQty(value ? value : 0)
          },
          tdClass: 'text-right',
          sortable: true,
        },
        // {
        //   key: 'email',
        //   label: 'ชื่อสินค้า',
        //   sortable: true,
        // },
        // {
        //   key: 'status',
        //   label: 'สถานะสินค้า',
        //   tdClass: 'text-center',
        //   thStyle: 'width:100px',
        //   sortable: true,
        // },
        // {
        //   key: 'status1',
        //   label: 'สถานะการขาย',
        //   tdClass: 'text-center',
        //   thStyle: 'width:100px',
        //   sortable: true,
        // },
      ],
      productSkuFields: [
        {
          key: 'index',
          formatter: (value, key, item) => {
            return FormatQty(value ? value : 0)
          },
          label: 'ลำดับ',
          thStyle: 'width:80px',
          sortable: true,
        },
        {
          key: 'id',
          label: 'รหัสสินค้า (OFM)',
          thStyle: 'width:120px',
          tdClass: 'text-center',
          sortable: true,
        },
        {
          key: 'product_names',
          label: 'ชื่อสินค้า',
          sortable: true,
        },
        {
          key: 'product_status.inventory',
          label: 'สถานะสินค้า',
          tdClass: 'text-center',
          thStyle: 'width:120px',
          sortable: true,
        },
        {
          key: 'product_status.sale',
          label: 'สถานะการขาย',
          tdClass: 'text-center',
          thStyle: 'width:120px',
          sortable: true,
        },
      ],
      showDataTable: false,
      pageOptions: [10, 25, 50, 100],
      perPage: 10,
      totalRecords: 0,
      listModel: {},
      pageNo: 1,
      firstRowOnPage: 0,
      lastRowOnPage: 0,
      productSkuItems: [],
    }
  },
  watch: {
    colorId: function() {
      this.getDetail()
    },
    listModel: function(value) {
      this.totalPages = value.totalPages
      this.firstRowOnPage = (value.pageNo - 1) * value.pageSize + 1
      this.lastRowOnPage =
        value.pageSize <= 0
          ? value.totalRecords
          : Math.min(value.pageNo * value.pageSize, value.totalRecords)
      this.totalRecords = value.totalRecords
      if (this.showDataTable) {
        this.$refs.producttable.localSortBy = ''
      }
      this.products = value.items
      this.perPage = value.pageSize
      this.pageNo = value.pageNo
    },
  },
  mounted() {
    if (this.colorId) {
      this.getDetail()
    }
  },
  methods: {
    async getDetail() {
      this.showDataTable = true
      let params = new URLSearchParams()
      params.append('color_ids', this.colorId)

      let result = await productService.getProductMasterListAsync(params)
      if (result.status === 200) {
        this.listModel = result.data
      } else if (
        (result.status && result.status !== 500) ||
        (result.response && result.response.status !== 500)
      ) {
        this.$utils.notification('error', result.response.data.message, 2000)
      }
    },
    async onClickPagination(pageNo) {
      this.search = ''
      let params = new URLSearchParams()
      params.append('pageSize', this.perPage)
      params.append('pageNo', pageNo)
      params.append('color_ids', this.colorId)

      let result = await productService.getProductMasterListAsync(params)
      if (result.status === 200) {
        this.listModel = result.data
      } else if (
        (result.status && result.status !== 500) ||
        (result.response && result.response.status !== 500)
      ) {
        this.$utils.notification('error', result.response.data.message, 2000)
      }
    },
    async onToggleDetails(row, product_id) {
      if (
        !this.products[row.index].productSkuItems ||
        this.products[row.index].productSkuItems.length == 0
      ) {
        await this.getProductSkuList(product_id)
      }
      row.toggleDetails()
    },
    async getProductSkuList(product_id) {
      let params = new URLSearchParams()
      params.append('pageSize', 99999)
      params.append('pageNo', 1)
      params.append('sort', 'product_id')
      let result = await productService.getProductSkuListByProductIdAsync(
        product_id,
        params
      )
      if (result.status === 200) {
        this.productSkuItems = result.data.items
        if (this.productSkuItems.length > 0) {
          var elementPos = this.products
            .map(function(x) {
              return x.id
            })
            .indexOf(this.productSkuItems[0].product_id)
          this.products[elementPos].productSkuItems = this.productSkuItems
        }
      } else if (
        (result.status && result.status !== 500) ||
        (result.response && result.response.status !== 500)
      ) {
        this.$utils.notification('error', result.response.data.message, 2000)
      }
    },
  },
}
</script>
